import React from "react";
import { useState } from "react";


function FormHomePage() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [tel, setTel] = useState("");
    console.log(name)
    console.log(email)
    console.log(tel)
    return (
        <div className="form-main">
            <label className="form-label">Name</label>
            <input className="form-input" onChange={(e) => setName(e.target.value)} typeof="text" placeholder="Name" name="name" id="email"></input>
            <label className="form-label">Email</label>
            <input className="form-input" onChange={(e) => setEmail(e.target.value)} typeof="email" placeholder="random_mail@gmail.com" name="email" id="email"></input>
            <label className="form-label">Phone Number</label>
            <input className="form-input" onChange={(e) => setTel(e.target.value)} typeof="tel" name="phone" placeholder="Phone Number" id="phone"></input>
            <button className="btn">Notify Me</button>
        </div>
    );
}

export default FormHomePage;